import { Col, Row, Skeleton } from "antd"
import dayjs from "dayjs"
import { useEffect, useState } from "react"

const TimmerSkeleton = () => {

  return (
    <Row className='home__deals-hotels--timmer' gutter={[5, 5]} wrap={false}>
      <Col>
        <Skeleton
          paragraph={false}
          styles={{
            title: {
              width: '3.6rem',
              height: '2.4rem',
              margin: 0
            }
          }}
          active
        />
      </Col>
      <Col>
        <Skeleton
          paragraph={false}
          styles={{
            title: {
              width: '3.6rem',
              height: '2.4rem',
              margin: 0
            }
          }}
          active
        />
      </Col>
      <Col>
        <Skeleton
          paragraph={false}
          styles={{
            title: {
              width: '3.6rem',
              height: '2.4rem',
              margin: 0
            }
          }}
          active
        />
      </Col>
    </Row>
  )
}

export default TimmerSkeleton